import React from "react";
import PropTypes from "prop-types";
import getConfig from "next/config";
import Link from "next/link";

const {
  publicRuntimeConfig: {
    settings,
    content: { websiteTitle },
  },
} = getConfig();

const RegionsBox = ({ regions }) => (
  <div className="border border-transparent rounded-tr-xl rounded-bl-xl stores-image p-6 lg:px-16 lg:pt-8">
    <ul className="flex flex-wrap text-left font-normal leading-4 m-0 p-0 -ml-3">
      {regions.map((region) => {
        return (
          <li
            className="w-1/2 sm:w-1/4 md:w-1/5 pl-3 lg:leading-23.4 leading-28.6 -tracking-0.33"
            key={region.id}
          >
            <Link
              href={`${settings.baseUrl}/magazine/${region.url_key}/`}
              passHref
            >
              <a title={`Magazinele ${websiteTitle} din ${region.name}`}>
                {region.name}
              </a>
            </Link>
          </li>
        );
      })}
    </ul>
  </div>
);

RegionsBox.propTypes = {
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ),
};

export default RegionsBox;
